<div class="order-reschedule">
  <div class="order-reschedule__header">
    <span class="order-reschedule__header__title">Reprogramar pedido</span>
    <button mat-icon-button (click)="closeDialog()" data-testid="reschedule-dialog-close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="order-reschedule__container">
    @if (state.isError()) {
      <div class="order-reschedule__message" data-testid="reschedule-dialog-error">
        <app-horus-message-general nameIcon="errorMessageIcon" btnAction="INTENTAR NUEVAMENTE"
          (action)="state.retry()">
          <span style="color:#F14B26; font-size: 14px; line-height: 25px;">Lo sentimos</span><br>
            Hubo un
           <strong>
             error al intentar cargar
           </strong>
            las fechas disponibles para reprogramación.
        </app-horus-message-general>
      </div>
    }
    @else if (state.isAllowedToReschedule()) {
      <form [formGroup]="rescheduleOrderForm" class="order-reschedule__body">
        <div  class="order-reschedule__container_v2">
          <div class="order-reschedule__info">
            <span>{{data.orderId}}</span>
          </div>
          <div class="order-reschedule__content">
            <mat-button-toggle-group formControlName="rescheduleDate" class="order-reschedule__dates"
              [hideSingleSelectionIndicator]="true" appearance="legacy" data-testid="reschedule-dialog-date-group">
              <mat-button-toggle class="order-reschedule__dates__button"
                *ngFor="let fecha of state.visibleDates()" [value]="fecha" data-testid="reschedule-dialog-date-btn">
                {{ fecha | availableDatePipe }}
              </mat-button-toggle>
            </mat-button-toggle-group>
            <div class="order-reschedule__see-more"
              *ngIf="state.availableDates().length > 7">
              @if (state.isShowingAllDates()) {
              <button class="order-reschedule__see-more__button" mat-button
                (click)="state.showFewerDates()" data-testid="reschedule-dialog-show-less-btn">
                <mat-icon>calendar_today</mat-icon>
                Ver menos fechas
              </button>
              } @else {
              <button horusBtn horusBtnVariant="ghost"  (click)="state.showMoreDates()" data-testid="reschedule-dialog-show-more-btn">
                <mat-icon>calendar_today</mat-icon>
                Ver más fechas
              </button>
              }
            </div>
          </div>
        </div>
      </form>
      <div class="order-reschedule__footer">
        <div class="order-reschedule__footer__options">
          <button horusBtn  [disabled]="rescheduleOrderForm.invalid"
            (click)="rescheduleOrder()" data-testid="reschedule-dialog-submit-btn">REPROGRAMAR PEDIDO</button>
          <button horusBtn horusBtnVariant="outline-default"
            (click)="closeDialog()"  data-testid="reschedule-dialog-cancel-btn">CANCELAR</button>
        </div>
      </div>
    }
    @else if (!state.isLoading()) {
      <div class="order-reschedule__message" data-testid="reschedule-dialog-not-allowed">
        <app-horus-message-general
          nameIcon="noDataMessageIcon"
          btnAction="INGRESAR TICKET"
          (action)="redirectToAria()">
          <span style="color:#F6D44D; font-size: 14px; line-height: 25px;">No podemos ejecutar la acción</span><br>
          <span style="font-weight: 400;">Este pedido <strong>no cumple las condiciones para ser reprogramado</strong>.</span>
        </app-horus-message-general>
      </div>
    }
    @else {
      <div class="order-reschedule__loading" data-testid="reschedule-dialog-loading">
        <app-horus-loading size="S"></app-horus-loading>
      </div>
    }
  </div>
</div>
